import { ALL_STORES } from "@/lib/stores";
import { PageHeader } from "@/components/site/Reveal";
import { Shop } from "@/components/site/Shop";
import { Story } from "@/components/site/Story";
import { Reactions } from "@/components/site/Reactions";
import { Reviews } from "@/components/site/Reviews";
import { Nutrition } from "@/components/site/Nutrition";
import { Faq } from "@/components/site/Faq";
import { BeyondBusiness } from "@/components/site/BeyondBusiness";
import { TeamThanks } from "@/components/site/TeamThanks";
import { Stores } from "@/components/site/Stores";

export const ShopPage = () => (
  <>
    <PageHeader testid="shop-page-header" eyebrow="Live from our store" title={["Pick a flavour,", "or build a box."]}
      sub="Prices and stock sync live from swolebears.ca. Checkout is handled securely by Shopify." />
    <Shop />
  </>
);

export const StoryPage = () => (
  <>
    <PageHeader testid="story-page-header" eyebrow="Our story · Rory Fox, founder" title={["A 14-year-old,", "$300 and a", "sweet tooth."]}
      sub="Swole Bears started from a personal need: a kid who loved candy and wanted something better for him." />
    <Story />
    <TeamThanks />
    <BeyondBusiness />
  </>
);

export const StoresPage = () => (
  <>
    <PageHeader testid="stores-page-header" eyebrow={`${ALL_STORES.length} stores and counting`} title={["Find us on a", "shelf near you."]}
      sub="Sobeys, Lawtons, Harvest Clean Eats, local gyms and more. Find a store near you across Atlantic Canada, Ontario and Quebec." />
    <Stores />
  </>
);

export const ReviewsPage = () => (
  <>
    <PageHeader testid="reviews-page-header" eyebrow="5.0 stars on swolebears.ca" title={["Who knew protein", "could taste this good?"]}
      sub="Gym-goers, travellers, snack lovers and parents. Here's what people say after their first bag." />
    <Reactions />
    <Reviews />
  </>
);

export const NutritionPage = () => (
  <>
    <PageHeader testid="nutrition-page-header" eyebrow="Nothing to hide" title={["Read the label.", "We want you to."]} />
    <Nutrition />
  </>
);

export const FaqPage = () => (
  <>
    <PageHeader testid="faq-page-header" eyebrow="FAQ" title={["Good questions."]} sub="Still curious? Message us on Instagram, Rory reads every one." />
    <Faq />
  </>
);
